const { UID_PART_LENGTH } = require('./constants');

/**
 * Generate a time based uid.
 * @returns {String}
 */
const uid = () => `${Math.random()}`.slice(-UID_PART_LENGTH) + `${Date.now()}`.slice(UID_PART_LENGTH);

module.exports = uid;
